function base64ToBlob(base64Data, contentType) {
    const binaryString = window.atob(base64Data);
    const binaryArray = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
        binaryArray[i] = binaryString.charCodeAt(i);
    }

    return new Blob([binaryArray], {type: contentType});
}

function downloadDocuments(data) {
    if (!data.documents || !Array.isArray(data.documents))
        return;

    for (let i in data.documents) {
        const doc = data.documents[i];
        const blob = base64ToBlob(doc.base64, `application/${doc.format}`);
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.setAttribute('download', doc.filename);
        document.body.appendChild(link);
        link.click();
    }
}

function downloadBlob(pdfUrl, filename) {
    const link = document.createElement('a');
    link.href = pdfUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
}

export {
    base64ToBlob, downloadDocuments, downloadBlob
}